module.exports = __webpack_public_path__ + "static/img/5.5c615cf0.png";